import { render } from "./InfoModal.vue?vue&type=template&id=9e220560&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=9e220560&scoped=true&lang=css"

import exportComponent from "/var/www/gigs.mciafc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e220560"]])

export default __exports__